import React, { useState, useEffect } from 'react';
import { Grid, TextField, Divider, FormControl, IconButton, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Button, CircularProgress } from '@mui/material';
import { SkillItemForServices } from './AddSection';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { ReactComponent as AiLogo } from "../../../../Assets/img/icons/ai-rewrite-logo.svg";
import useApi from '../../../Utilities/useAPI';
import { DeleteLightBox } from '../ProfessionalProfile';
import PreviewFileItem from '../../../Utilities/PreviewFileItem';
import DeleteIcon from '@mui/icons-material/Delete';
import { v4 as uuidv4 } from 'uuid';
import { MAX_DESC_LENGTH } from '../../../../config/constant';
import { deleteAwardReducer, getAwardsReducer, postAwardsBlobReducer } from '../../../../Redux/Reducers/ProfileReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useQuantityContext } from '../../../QuantityContext';
import { useProfileContext } from '../../../../Components/ProfileDetailContext';

const AddAwards = ({ open, onClose, isEditing, editAwardIndex, handleGenerateDescription, handleSuccess, handleFailure, awardDetails }) => {
    const { awardsList
        , setAwardsList,
        updateAwardsAttachments, setAwardEditIndex, setAddSection } = useProfileContext();

    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const { callApiFunction } = useApi();

    const { handleInfo } = useQuantityContext();
    const dispatch = useDispatch();

    const AwardsBlob = useSelector((state) => state?.ProfileArray?.awardsBlob);

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentYear = new Date().getFullYear();
    const years = Array.from(
        { length: currentYear - 1970 + 1 },
        (_, index) => currentYear - index
    );
    // console.log("awardDetails awardDetails", awardDetails)
    const [currentAward, setCurrentAward] = useState({
        id: awardDetails?.id || '',
        awardTitle: awardDetails?.award_title || '',
        associatedWith: awardDetails?.associated_with || '',
        awardIssuer: awardDetails?.issuer || '',
        issueMonth: awardDetails?.issue_month || '',
        issueYear: awardDetails?.issue_year || '',
        awardDescription: awardDetails?.description || '',
        awardAttachments: awardDetails?.attachments || [],
        isPublic: awardDetails?.isPublic || true,
    })

    const resetCurrentAward = () => {
        setCurrentAward({
            id: '',
            awardTitle: '',
            associatedWith: '',
            awardIssuer: '',
            issueMonth: '',
            issueYear: '',
            awardDescription: '',
            awardAttachments: [],
            isPublic: true,
        })
    }

    const [isAwardsDelete, setIsAwardsDelete] = useState(false);

    // useEffect(() => {
    //     if (isEditing && editAwardIndex !== null) {
    //         setCurrentAward(awardsList[editAwardIndex]);
    //     } else {
    //         resetCurrentAward();
    //     }
    // }, [isEditing, editAwardIndex, awardsList]);

    const updateCurrentAward = (updatedField) => { //with both Key and Pair
        setCurrentAward((prevDetails) => ({
            ...prevDetails,
            ...updatedField,
        }));
    };

    const updateCurrentAttachments = (newAttachment) => {
        const attachmentWithId = { ...newAttachment, id: uuidv4() };
        setCurrentAward((prevState) => ({
            ...prevState,
            awardAttachments: [...(prevState?.awardAttachments || []), attachmentWithId],
        }));
    };

    const handleRemoveAttachment = (id) => {
        console.log('Entered removeAwardAttachments to delete id', id, currentAward?.awardAttachments);
        setCurrentAward((prevState) => ({
            ...prevState,
            awardAttachments: prevState?.awardAttachments?.map((attachment) =>
                attachment?.id === id ? { ...attachment, toBeDeleted: true } : attachment
            ),
        }));
    };

    const handleAwardInputChange = (fieldName) => (event) => {
        const newValue = event.target.value;
        updateCurrentAward({ [fieldName]: newValue });
        setErrors({
            ...errors,
            [fieldName]: false,
        });
    };

    const requiredFields = ['awardTitle'];

    const [errors, setErrors] = useState({
        awardTitle: false,
    });

    // --------------- API Calling Functions ----------------------

    const handleSave = async (e) => {
        e.preventDefault();
        if (submitting) return;
        const newErrors = { ...errors };

        requiredFields.forEach(field => {
            if (!currentAward[field]) {
                newErrors[field] = true;
            } else {
                newErrors[field] = false;
            }
        });

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(error => error);

        if (hasErrors) return;
        setSubmitting(true);
        try {
            const endpoint = 'awardsCreateUpdate';
            const { id, awardTitle, awardIssuer, associatedWith, issueMonth, issueYear, awardDescription, awardAttachments } = currentAward;
            const currentAwardAttachments = awardAttachments
                ?.filter(attachment => !attachment.toBeDeleted) // Exclude attachments marked for deletion
                ?.map((attachment) => ({
                    document_name: attachment?.name || attachment?.document_name,
                    document_link: attachment?.data || attachment?.document_url,
                    document_type: attachment?.type || attachment?.document_type,
                    document_meta: {
                        document_size: attachment?.size || attachment?.size
                    },
                    is_verified: false,
                    is_public: false
                }));
            // const payload = {
            //     id: id,
            //     award_title: awardTitle,
            //     associated_with: associatedWith,
            //     issuer: awardIssuer,
            //     issue_month: issueMonth,
            //     issue_year: issueYear,
            //     description: awardDescription,
            //     attachments: currentAwardAttachments
            // };

            // console.log("Payload", payload)

            console.log("Award ID", id);
            const formData = new FormData();

            // Append text fields
            formData.append("id", id);
            formData.append("award_title", awardTitle);
            formData.append("associated_with", associatedWith);
            formData.append("issuer", awardIssuer);
            formData.append("issue_month", issueMonth);
            formData.append("issue_year", issueYear);
            formData.append("description", awardDescription);

            console.log("AWARDS PROJECTS", currentAwardAttachments);
            // Handling attachments
            if (currentAwardAttachments?.length > 0) {
                setLoading(true);
                handleInfo("Please wait to complete the process")
                for (let i = 0; i < currentAwardAttachments?.length; i++) {
                    try {
                        const fileName = currentAwardAttachments[i]?.document_name;
                        const fileType = currentAwardAttachments[i]?.document_type;
                        const fileSize = currentAwardAttachments[i]?.document_meta?.document_size; // Get size from JSON

                        const documentLink = currentAwardAttachments[i]?.document_link;

                        console.log(`File: ${fileName}, Size: ${fileSize}, Link: ${documentLink},Type:${fileType}`);

                        // if (documentLink.startsWith("blob:http://localhost:3000/")) {

                        if (fileType === "url") {

                            const websiteLinks =
                            {
                                "document_name": currentAwardAttachments[i]?.document_name,
                                "document_link": currentAwardAttachments[i]?.document_link,
                                "document_type": currentAwardAttachments[i]?.document_type,
                                "document_meta": {
                                    "document_size": currentAwardAttachments[i]?.document_meta?.document_size || 0
                                },
                                "is_verified": currentAwardAttachments[i]?.is_verified,
                                "is_public": currentAwardAttachments[i]?.is_public
                            };
                            // console.log("website_links[]", JSON.stringify(websiteLinks))
                            formData.append("website_links[]", JSON.stringify(websiteLinks));
                        } else {
                            const response = await fetch(documentLink);
                            console.log("RESPONSE", response);
                            const blob = await response.blob();

                            const file = new File([blob], fileName, { type: fileType });
                            console.log("attachmentsBlob", blob, fileName)
                            formData.append("attachments", blob, fileName);
                        }

                    } catch (error) {
                        console.error("Error fetching attachment:", error);
                    }
                }
                setLoading(false);
            }

            try {
                setLoading(true);
                // const response = await callApiFunction(endpoint, payload);
                const response = await dispatch(postAwardsBlobReducer(formData))
                if (response?.payload?.statusCode === 200) {
                    // console.log("Add award AwardBlob id", id)

                    await dispatch(getAwardsReducer())
                    const newId = AwardsBlob?.id;
                    // if (editAwardIndex !== null) {
                    //     const updatedAwardsList = awardsList.map((project, index) =>
                    //         index === editAwardIndex ? currentAward : project
                    //     );
                    //     setAwardsList(updatedAwardsList);

                    // } else {
                    //     const newAward = { ...currentAward, id: newId };
                    //     setAwardsList((prevList) => [...prevList, newAward]);
                    // }

                    setAwardEditIndex(null);
                    resetCurrentAward();
                    onClose();
                    handleSuccess("Added Successfully.");
                    // setAddSection((prevState) => ({
                    //     ...prevState,
                    //     professionalAwards: true
                    // }));
                } else {
                    console.log("Failed POST for Awards");
                    handleFailure();
                }
            } catch (error) {
                console.log("Error Saving Awards Details: ", error);
                handleFailure();
            } finally {
                setLoading(false);
            }
        } finally {
            setSubmitting(false);
        }
    }

    const handleDelete = async () => {
        const endpoint = 'awardsDelete';
        const { id } = currentAward;
        const params = { id };
        try {
            // const response = await callApiFunction(endpoint, params);
            const response = await dispatch(deleteAwardReducer(id))
            if (response?.payload?.statusCode === 200) {
                await dispatch(getAwardsReducer());
                onClose();
                setIsAwardsDelete(false);
                // if (editAwardIndex !== null) {
                //     const updatedAwardsList = awardsList.filter((award, index) => index !== editAwardIndex);
                //     setAwardsList(updatedAwardsList);

                // }
                setAwardEditIndex(null);
                resetCurrentAward();
                handleSuccess('', 'Delete');
                // setAddSection((prevState) => ({
                //     ...prevState,
                //     professionalAwards: true
                // }));
            } else {
                console.log('Could not DELETE project', response);
                handleFailure('', 'Delete');
            }
        } catch (error) {
            console.log('TRY for DELETE failed', error, params);
            handleFailure('', 'Delete');
        }
    }

    return (
        open && (
            <>
                <div className="lightbox-overlay">
                    <div className="lightbox-content-2 p-0 thin-lightbox">
                        <div style={{ textAlign: "left" }}>
                            <div className="d-flex justify-content-between px-4 pt-4">
                                <div className="card-edit-info-heading">
                                    <div className="profile-modal-heading1 mb-2">{isEditing ? 'Edit Honors and Awards' : 'Add Honors and Awards'}</div>
                                    <div className="sub-text-lightbox">Include your Honors and Awards here</div>
                                </div>
                                <IconButton className="modal-close-button" onClick={onClose}>
                                    <CloseRounded />
                                </IconButton>
                            </div>

                            <Divider className='my-2' sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} />

                            <div className="px-4 pb-4 pt-2">
                                <div className="my-2 user-details-container awards-form">

                                    <TextField
                                        name="awardTitle"
                                        label="Award Title"
                                        className="summary-field"
                                        fullWidth
                                        value={currentAward?.awardTitle}
                                        onChange={handleAwardInputChange('awardTitle')}
                                        required
                                        error={errors.awardTitle}
                                    />

                                    <TextField
                                        name="associatedWith"
                                        label="Associated with"
                                        placeholder="Associated with"
                                        fullWidth
                                        value={currentAward?.associatedWith}
                                        onChange={handleAwardInputChange('associatedWith')}
                                    />

                                    <TextField
                                        name="issuer"
                                        label="Issuer"
                                        placeholder="Issuer"
                                        fullWidth
                                        value={currentAward?.awardIssuer}
                                        onChange={handleAwardInputChange('awardIssuer')}
                                    />

                                    <div>
                                        <div className='mb-2'>Issue Date</div>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="startMonth-label">Month</InputLabel>
                                                    <Select
                                                        labelId="month-label"
                                                        name="issueMonth"
                                                        value={currentAward?.issueMonth}
                                                        onChange={handleAwardInputChange('issueMonth')}
                                                        label="Month"
                                                        className="text-left"
                                                    >
                                                        {months.map((month, index) => (
                                                            <MenuItem key={index} value={month}>
                                                                {month}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="year-label">Year</InputLabel>
                                                    <Select
                                                        labelId="year-label"
                                                        name="issueYear"
                                                        value={currentAward?.issueYear}
                                                        onChange={handleAwardInputChange('issueYear')}
                                                        label="Year"
                                                        className="text-left"
                                                    >
                                                        {years?.map((year, index) => (
                                                            <MenuItem key={index} value={year}>
                                                                {year}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </div>

                                    <TextField
                                        multiline
                                        rows={3}
                                        name="description"
                                        label="Description"
                                        placeholder="Description (500 characters Maximum)"
                                        autoComplete="off"
                                        variant="outlined"
                                        fullWidth
                                        inputProps={{ maxLength: MAX_DESC_LENGTH }}
                                        value={currentAward?.awardDescription}
                                        onChange={handleAwardInputChange('awardDescription')}
                                    />

                                    <div className="d-flex justify-content-end align-items-start my-2">
                                        {/* <div className="invite-modal-subtitle">Enable AI Generation with minimum 15 words</div> */}
                                        <Button
                                            variant="outlined"
                                            sx={{ color: "#0044C6" }}
                                            className="ai-rewrite-button"
                                            onClick={() => handleGenerateDescription(
                                                {
                                                    awardTitle: currentAward?.awardTitle,
                                                    issuer: currentAward?.awardIssuer,
                                                    associatedWith: currentAward?.associatedWith,
                                                    description: currentAward?.awardDescription,
                                                },
                                                "award",
                                                "awardDescription",
                                                updateCurrentAward
                                            )
                                            }
                                            disabled={!currentAward?.awardTitle}
                                            startIcon={<AiLogo />}
                                        >
                                            Generate
                                        </Button>
                                    </div>

                                    <div>
                                        <h2 className="headingforContent text-left mt-1 p-0">Attachments</h2>
                                        <div className='text-left subtitle_services_section mt-1 mb-2'>Upload Media like images, documents, sites or presentations</div>
                                        <SkillItemForServices maxSize={5000000} className="text-left" updateAttachments={updateCurrentAttachments} />
                                        {currentAward?.awardAttachments
                                            ?.filter(attachment => !attachment.toBeDeleted)
                                            ?.map((attachment, index) => (
                                                <div key={index} className="add-project-modal my-3">
                                                    {typeof attachment === 'string' ? (
                                                        <a href={attachment}>
                                                            <div className="design-lighter-textNew">{attachment}</div>
                                                        </a>
                                                    ) : (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="Documents-Attachments">
                                                                <PreviewFileItem file={attachment} fontColor="#00000099" />
                                                            </div>
                                                            <IconButton onClick={() => handleRemoveAttachment(attachment?.id)}>
                                                                <DeleteIcon />
                                                            </IconButton >
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                    </div>

                                </div>
                                {isEditing ?
                                    <div className="mt-2 d-flex justify-content-between">
                                        <Button sx={{ color: '#0044C6' }} onClick={() => { setIsAwardsDelete(true) }}>
                                            Delete
                                        </Button>
                                        <Button variant="contained" sx={{ backgroundColor: '#0044C6' }} onClick={handleSave}>
                                            Save
                                        </Button>
                                    </div>
                                    :
                                    <div className="mt-2 d-flex justify-content-end">
                                        <Button variant="contained" sx={{ backgroundColor: '#0044C6' }} onClick={handleSave} disabled={loading || submitting}>
                                            {submitting ? (
                                                <span className="d-flex align-items-center">
                                                    <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                                    Adding...
                                                </span>
                                            ) : (
                                                "Add"
                                            )}
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    {isAwardsDelete &&
                        <DeleteLightBox Title="Award" Label="Do you really want to remove this Award?" LightBoxCloseFunction={setIsAwardsDelete}
                            DeleteFunction={handleDelete} clearFields={undefined} />
                    }

                </div>
            </>
        )
    );
}

export default AddAwards;